module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "poem3",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "part1"
    }
  }), _c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_vm._v("We ran like young wild furies,")])]), _c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_c('p', {
    staticClass: "poem3"
  }, [_vm._v("where angels feared to tread.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("The woods were dark and deep.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Before us demons fled.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We checked Coke bottle bottoms")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("to see how far was far.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Our worlds of magic wonder")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("were never reached by car.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We loved our dogs like brothers,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("our bikes like rocket ships.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We were going to the stars,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("to Mars we’d make round trips.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We swung on vines like Tarzan,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("and flashed Zorro’s keen blade.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We were James Bond in his Aston,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("we were Hercules unchained.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We looked upon the future")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("and we saw a distant land,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("where our folks were always ageless,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("and time was shifting sand.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("We filled up life with living,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("with grins, scabbed knees, and noise.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("In glass I see an older man,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("but this book’s for the boys.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a89d42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book3/4-start.vue
// module id = 87
// module chunks = 0